export const STAMMDATEN_API: string = import.meta.env.VITE_STAMMDATEN_API;
export const AUFTRAG_API: string = import.meta.env.VITE_AUFTRAGSBEARBEITUNG_API;
export const PERMISSIONS_API: string = import.meta.env.VITE_PERMISSIONS_API;
export const MESSAGES_API: string = import.meta.env.VITE_MESSAGES_API;
export const DOCUMENTS_API: string = import.meta.env.VITE_DOCUMENTS_API;
export const MAILING_API: string = import.meta.env.VITE_MAILING_API;
export const BILLING_API: string = import.meta.env.VITE_BILLING_API;
export const AI_GATEWAY_API: string = import.meta.env.VITE_AI_GATEWAY_API;
export const AUDITING_API: string = import.meta.env.VITE_AUDITING_API;
export const EXTERNAL_ERP_PROXY_API: string = import.meta.env.VITE_EXTERNAL_ERP_PROXY_API;
export const SCHEDULING_API: string = import.meta.env.VITE_SCHEDULING_API;
export const AGENTIC_ORCHESTRATOR_API: string = import.meta.env.VITE_AGENTIC_ORCHESTRATOR_API;
